<template>
  <b-container class="html-block-full-width-overflow" fluid>
    <b-container>
      <b-row>
        <b-col>
          Become the most recognized and valuable domestic brand.
        </b-col>
        <b-col>
          Background Image Goes Here!
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style>
.html-block-full-width-overflow {
  background-color: #0084B3;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
}
</style>



// WEBPACK FOOTER //
// core/vue/components/HTMLBlock1.vue